<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <span class="section-title">NÓMINA DE EMPLEADOS</span>

            <!-- Buscador y rango de fechas -->
            <div class="row">
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar empleado..."
                  @input="fetchData(null)"
                />
              </div>
              <div class="col-md-4 mb-3">
                <label for="startDate" class="mb-1">Fecha inicio</label>
                <input
                  type="date"
                  v-model="startDate"
                  id="startDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
              <div class="col-md-4 mb-3">
                <label for="endDate" class="mb-1">Fecha fin</label>
                <input
                  type="date"
                  v-model="endDate"
                  id="endDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0 table-nomina-symmetric">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 th-empleado">Empleado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 th-tareas">Tareas realizadas (mes)</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 th-acciones">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td class="td-empleado">
                      <div class="d-flex px-2 py-1">
                        <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm td-tareas">
                      <h6 class="mb-0 text-sm">
                        {{ value.tasks_in_range ?? 0 }}
                      </h6>
                    </td>
                    <td class="align-middle text-center text-sm td-acciones">
                      <a
                        @click="viewProductions(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer me-3 d-inline-flex align-items-center"
                        data-toggle="tooltip"
                        data-original-title="Historial de trabajos"
                      >
                        <i class="fas fa-file-invoice-dollar me-1"></i>
                        <span>Trabajos</span>
                      </a>
                      <a
                        @click="viewPaymentHistory(value.id, value.name)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer d-inline-flex align-items-center"
                        data-toggle="tooltip"
                        data-original-title="Historial de pagos"
                      >
                        <i class="fas fa-history me-1"></i>
                        <span>Pagos</span>
                      </a>
                    </td>

                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="3" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      startDate: '',
      endDate: '',
    };
  },
  computed: {
    ...mapGetters('users', ['allUsers', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.users.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.users.lastPage; // Obtiene la última página
    },
    data() {
      return this.allUsers; // Retorna los empleados desde el store
    },
    links() {
      return this.$store.getters['users/links']; // Retorna los links
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };
      await this.$store.dispatch('users/fetchUsers', params);
    },
    async viewProductions(userId) {
      this.$router.push({ name: "Nomina Productions", params: { userId } });
    },
    viewPaymentHistory(userId, userName) {
      this.$router.push({ name: "Nomina Payments", params: { userId, userName } });
    },
    async addPaid(userId) {
      const { value: formValues } = await Swal.fire({
        title: "Agregar Pago",
        html: `
          <div>
            <input id="swal-price" class="swal2-input mt-2" placeholder="Precio a abonar" style="width:100%;margin:0px">
            <textarea id="swal-observation" class="swal2-input mt-2" placeholder="Observación" style="width:100%;margin:0px;height:80px;"></textarea>
          </div>`,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const price = parseFloat(document.getElementById("swal-price").value.trim());
          const observation = document.getElementById("swal-observation").value.trim();

          if (isNaN(price) || price <= 0) {
            Swal.showValidationMessage("El precio debe ser un número válido y positivo");
            return false;
          }

          return { price, observation };
        },
      });

      if (formValues) {
        try {
          const payment = {
            id: 0,
            production_user_id: userId,
            total: formValues.price,
            observation: formValues.observation,
          };

          const response = await this.$store.dispatch("productionPayments/save", payment);

          if (response && response.status >= 200 && response.status < 300) {
            Swal.fire("Éxito", "Pago registrado correctamente", "success");
            this.fetchData();
          } else {
            throw new Error(response.data.message || "Error al registrar el pago");
          }
        } catch (error) {
          Swal.fire("Error", "No se pudo registrar el pago", "error");
        }
      }
    }


  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

/* Tabla con columnas simétricas y espaciado uniforme */
.table-nomina-symmetric {
  table-layout: fixed;
  width: 100%;
}
.table-nomina-symmetric .th-empleado,
.table-nomina-symmetric .td-empleado {
  width: 40%;
  padding-left: 1rem;
  padding-right: 1rem;
}
.table-nomina-symmetric .th-tareas,
.table-nomina-symmetric .td-tareas {
  width: 35%;
  padding-left: 1rem;
  padding-right: 1rem;
}
.table-nomina-symmetric .th-acciones,
.table-nomina-symmetric .td-acciones {
  width: 25%;
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>